import React, { createContext, useContext, useState } from 'react';

const RefreshContext = createContext<
  { refreshKey: number; triggerRefresh: () => void } | undefined
>(undefined);

export const RefreshProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const triggerRefresh = () => setRefreshKey((prev) => prev + 1);

  return (
    <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
      {children}
    </RefreshContext.Provider>
  );
};

export const useRefresh = () => {
  const context = useContext(RefreshContext);
  if (!context)
    throw new Error('useRefresh must be used within a RefreshProvider');
  return context;
};
